import { render, staticRenderFns } from "./PunchClockCountdown.vue?vue&type=template&id=048122f9&scoped=true&"
import script from "./PunchClockCountdown.vue?vue&type=script&setup=true&lang=js&"
export * from "./PunchClockCountdown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PunchClockCountdown.vue?vue&type=style&index=0&id=048122f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048122f9",
  null
  
)

export default component.exports